// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"3c588029","259":"bf15aa72","549":"a45b0035","702":"d5aee920","703":"e3667c76","843":"d50a11af","897":"cf51ea54","906":"c2093aeb","957":"64552564"}[chunkId] + ".chunk.js";
};